import { useState } from "react";
import { Settings2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { api } from "../../lib/api";
import { ServerPriorityFields } from "./ServerPriorityFields";

const FIELDS = [
  ["min_download", "Min download (Mbps)", "Flag if below"],
  ["min_upload", "Min upload (Mbps)", "Flag if below"],
  ["max_ping", "Max ping (ms)", "Flag if above"],
  ["max_jitter", "Max jitter (ms)", "Flag if above"],
];

export const ThresholdsDialog = ({ value, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(value);
  const save = async () => {
    try {
      const body = { ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(form[k])])), server_priority: form.server_priority?.length ? form.server_priority : ["cloudflare", "app"], custom_server_url: form.custom_server_url?.trim() || null, custom_server_name: form.custom_server_name?.trim() || null };
      await api.saveSettings(body);
      toast.success("Issue criteria updated");
      setOpen(false); onSaved();
    } catch (e) { toast.error(e.response?.status === 422 ? "Check values: custom server needs a valid http(s) URL" : "Failed to save"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (o) setForm(value); }}>
      <DialogTrigger asChild>
        <button data-testid="thresholds-button" className="btn-ghost flex items-center gap-1 text-xs"><Settings2 className="w-4 h-4" /> Settings</button>
      </DialogTrigger>
      <DialogContent className="rounded-none bg-[#121212] border-white/10 text-white font-mono max-h-[90vh] overflow-y-auto" data-testid="thresholds-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl font-normal tracking-wide">Settings</DialogTitle></DialogHeader>
        <DialogDescription className="text-xs text-neutral-500">Issue criteria apply to all tests, including past ones.</DialogDescription>
        <div className="grid grid-cols-2 gap-4 mt-2">
          {FIELDS.map(([k, label, hint]) => (
            <label key={k} className="block">
              <span className="label">{label}</span>
              <input data-testid={`threshold-${k}`} type="number" step="any" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="field w-full mt-1" />
              <span className="text-[10px] text-neutral-600">{hint}</span>
            </label>
          ))}
        </div>
        <ServerPriorityFields form={form} setForm={setForm} />
        <button data-testid="save-thresholds-button" onClick={save} className="btn-primary py-3 mt-2 font-display text-2xl tracking-widest">Save</button>
      </DialogContent>
    </Dialog>
  );
};
